import { render, staticRenderFns } from "./terms.page.vue?vue&type=template&id=076ae4fe&scoped=true&"
import script from "./terms.page.vue?vue&type=script&lang=js&"
export * from "./terms.page.vue?vue&type=script&lang=js&"
import style0 from "./terms.page.vue?vue&type=style&index=0&id=076ae4fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ae4fe",
  null
  
)

export default component.exports